import React from 'react';

const Checkbox = ({ children, ...props}) => {
  return (
    <div className="yodel-checkbox-container">
      <input type="checkbox" {...props} tabIndex="0" />
      <label htmlFor={props.id}>
        {children}
        <span className="yodel-checkbox-icon"></span>
      </label>
    </div>
  );
}

export default Checkbox;
